import http from '@/utils/http'
import Cookie from 'js-cookie'

const login = ({ email, password, platformName }) => http()
  .post('/oauth/token', {
    grant_type: 'password',
    scope: 'admin',
    username: email,
    password
  }, {
    headers: {
      PlatformTokenName: platformName
    }
  })
  .then(token => {
    Cookie.set('authorization', token.data)
    return token
  })

const logout = () => {
  const token = (Cookie.getJSON('authorization') || {}).access_token
  return http()
    .post('/oauth/revoke', { token })
    .then(_ => Cookie.remove('authorization'))
}

const connectAs = ({ adminId }) => http()
  .post('/connect_as', { admin_id: adminId })
  .then(token => {
    Cookie.set('authorization', token.data)
    return token
  })

export default {
  login,
  logout,
  connectAs
}



// WEBPACK FOOTER //
// ./src/api/session.js